import { createSelector } from "reselect";
import { AppState } from "../store";
import { AuthStateI } from "./authTypes";

const selector = (state: AppState) => state.authReducer;

export const authSelector = createSelector([ selector ], (state: AuthStateI) => state);

export const helpInfoSelector = createSelector(
  [ selector ],
  ({ helpInfo, helpInfoLoading, helpInfoError }: AuthStateI) => ({ helpInfo, helpInfoLoading, helpInfoError }),
);

export const userSelector = createSelector([ selector ], ({ user }: AuthStateI) => ({ user }));
